import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";


export class CloudInitAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = localization;
    }
}

export const cloud_init_api = {
    async get() {
        try {
            return await restfulApiClient.get("cloud_init", 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new CloudInitAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async getFileContents(name: string) {
        try {
            return await restfulApiClient.get(`cloud_init/${name}`, 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new CloudInitAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async generate(name: string, data: string) {
        try {
            return await restfulApiClient.post("cloud_init", 1, {
                name: name,
                data: data,
            });
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new CloudInitAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }

    },

    async modify(name: string, new_name: string, data: string) {
        try {
            return await restfulApiClient.patch(`cloud_init/${name}`, 1, {
                name: name,
                new_name: new_name,
                data: data,
            });
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new CloudInitAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async delete(name: string) {
        try {
            return await restfulApiClient.delete(`cloud_init/${name}`, 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new CloudInitAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async setDefault(name: string) {
        try {
            return await restfulApiClient.patch(`cloud_init/${name}/default`, 1, {default: true});
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new CloudInitAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }

    }
}